import { useMemo, useContext } from 'react';
import AuthContext from '../components/auth';

const usePermissions = (permissionsMap) => {
  const { user } = useContext(AuthContext);
  const { permissions: userPermissions } = user;

  return useMemo(() => {
    return Object.keys(permissionsMap).reduce((acc, key) => {
      acc[key] = permissionsMap[key].some((perm) =>
        userPermissions.includes(perm),
      );
      return acc;
    }, {});
  }, [userPermissions, permissionsMap]);
};

export default usePermissions;
